import { v4 as uuid } from "uuid";
import type { ProductTypeConfig, ProductOptions, ProductStatus, OptionConfig } from "../types";

const products: ProductTypeConfig<ProductOptions>[] = [];

export function registerProductType<T extends ProductOptions>(product: ProductTypeConfig<T>): void {
  products.push(product as unknown as ProductTypeConfig<ProductOptions>);
}

export function getProductType(name: string): ProductTypeConfig<ProductOptions> | undefined {
  return products.find((product) => product.name === name);
}

export interface CreatedProduct {
  name: string;
  uid: string;
  time: number;
  status: ProductStatus;
  options: ProductOptions;
}

export function createProduct(name: string): CreatedProduct {
  const productType = getProductType(name);

  if (!productType) {
    throw new Error(`Unknown product type: ${name}`);
  }

  return {
    name,
    uid: uuid(),
    time: Date.now(),
    status: "draft",
    options: Object.fromEntries(
      Object.entries(productType.options).map(([key, config]) => [
        key,
        (config as OptionConfig).defaultValue,
      ]),
    ) as unknown as ProductOptions,
  };
}
